module.exports = __webpack_public_path__ + "static/media/satelight image.6e2ba377.png";